const config = require("./config.json")
export default config
